import {LinePlotTemplateSettings} from './workspaceTemplatesQueries';

export const mappedBooleanDisplayValue = (value: boolean) => {
  return value ? 'On' : 'Off';
};

type TemplateSettings = LinePlotTemplateSettings;

type SettingsSection<T extends TemplateSettings> = {
  rows: {field: keyof T; newValue: T[keyof T]}[];
};

/**
 * Extracts settings values from template sections.
 * Reduces all rows in all sections to a single settings object using each row's field and newValue.
 */
export const extractSettingsFromSections = <T extends TemplateSettings>(
  sections: SettingsSection<T>[]
): T => {
  return sections.reduce<T>((acc, section) => {
    return section.rows.reduce((acc, row) => {
      acc[row.field] = row.newValue;
      return acc;
    }, acc);
  }, {} as T);
};
